module.exports = __webpack_public_path__ + "static/media/dennis_korn.f6640142.jpg";